import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

const ACTION_TYPES = {
  SUB_CATEGORY_LOADING: 'SUB_CATEGORY_LOADING',
  SUB_CATEGORY_LOADED: 'SUB_CATEGORY_LOADED',
  SUB_CATEGORY__RESET: 'SUB_CATEGORY__RESET',
};
const NAMESPACE = 'SubCategoryNav';

const contentContentStateSelector = (state) => state.header;
const subCatNavSelector = createSelector(contentContentStateSelector, (header) => (header ? header.subCatNav : null));

/**
 * Method to Reset the Performer Page redux state.
 *
 */
function resetSubCatDropdown() {
  return (dispatch) => {
    dispatch({type: ACTION_TYPES.SUB_CATEGORY__RESET});
  };
}

const subCatController = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    resetSubCatDropdown,
  },
  reducers: [ACTION_TYPES.SUB_CATEGORY_LOADING, ACTION_TYPES.SUB_CATEGORY_LOADED],
  mapStateToProps(state) {
    return {
      merchConfig: subCatNavSelector(state),
    };
  },
});

subCatController.addResetReducer([ACTION_TYPES.SUB_CATEGORY__RESET]);

export default subCatController;
